import { Text } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import React, { useRef } from "react";

let x = 0;
let rot = 0;
let direction = 1;

export default function Word({ position, range, rotation, title }) {
  const text = useRef(null);
    const color=  "#000000" ;
    const fontSize=  0.06;
    const fillOpacity=  1;
    const outlineColor= "#ffffff";
    const outlineWidth= 0.001;
    const outlineBlur= 0;
    const outlineOpacity= 1;
    const multiplier= 1;
    const move= false;
    const rotate= false;

  useFrame((state, delta) => {
    if (move) {
      x += 0.1 * direction * delta;
      if (x > range) direction = -1;
      if (x < -range) direction = 1;
      text.current.position.x = x;
    }

    if (rotate) {
      rot -= 0.01 * delta;
      rot %= Math.PI * 2;
      text.current.rotation.z = rot;
    }
  });

  const textProps = {
    anchorX: "center",
    anchorY: "middle",
    color,
    fontSize,
    fillOpacity,
    outlineColor,
    outlineWidth: outlineWidth * multiplier,
    outlineBlur: outlineBlur * multiplier,
    outlineOpacity
  };

  return (
    <mesh position={position} rotation={rotation} >
      <Text ref={text} {...textProps}>
        {title}
      </Text>
    </mesh>
  );
}
